import {
  handleUrl,
  myHeadersWithToken,
  myHeadersWithTokenContentType,
} from '../global';
import {
  DetailProps,
  GetAllAttachedFilesProps,
  GetAttachmentProps,
} from './types';

export const addAttachment = (data: FormData): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithToken(),
    body: data,
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/attachments`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const deleteAttachment = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithToken(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/attachments/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getAllAttachedFiles = (
  id: number,
  page: number,
  size: number
): Promise<GetAllAttachedFilesProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/work-orders/${id}/attachments?page=${page}&size=${size}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getAttachment = (id: number): Promise<GetAttachmentProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/attachments/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
